import React from "react";
import { Text } from "basis";

import {
  FEES,
  RATES,
} from "../../../../components/Promotions/Description/constants";
import { WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS } from "../../../../../assets/constants";
import { LessThanMinAmount } from "./LessThanMinAmount";

export const Deferred = ({ order }) => {
  if (order?.price < WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS) {
    return <LessThanMinAmount />;
  }

  return (
    <>
      <Text textStyle="body2" margin="0 0 3" align="center">
       Make payments at any time it suits you during the plan period. Lending criteria, T&C's and fees apply including a ${FEES["ESTABLISHMENT"]} establishment fee and ${FEES["GEM_VISA"]} annual fee (${FEES["GEM_VISA_HALF_YEARLY"]} half yearly). Interest (currently {RATES["GEM_VISA_NZ"]}% p.a.) applies after any interest free plan expires. Credit provided by Latitude Financial Services Limited.
      </Text>
    </>
  );
};
